/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Library_Ficc_NotesInputs */

const en_landing_library_ficc_notes = /** @type {(inputs: Landing_Library_Ficc_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FICC notes`)
};

/**
* | output |
* | --- |
* | "FICC notes" |
*
* @param {Landing_Library_Ficc_NotesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_library_ficc_notes = /** @type {((inputs?: Landing_Library_Ficc_NotesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Library_Ficc_NotesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_library_ficc_notes(inputs)
});